import React from "react"

export default function Blog029() {
  return (
    <section>
    <article>
    <h2>29. 12-23-2022</h2>
          <h3>Just before the holiday's</h3>
          <p>
          <strong>Hello everyone,</strong>
          <br /><br />
        

I am excited to share that I have recently created a new website using React.js and Tailwind CSS. For those who are unfamiliar, React.js is a popular JavaScript library for building user interfaces, and Tailwind CSS is a utility-based CSS framework.
<br /><br />
In addition to creating the website, I also filmed a 7-part tutorial series documenting the entire process. If you are interested in learning more about how I built the website, you can check out the tutorial series using the link below.
<br /><br />
One of the features I implemented on my website is the use of React Router for managing routes and navigation. This allows for a seamless experience for users as they browse through different pages on the website.
<br /><br />
I also created a header component that is displayed on every page of the website. This helps to provide a consistent look and feel as users navigate through the site.
<br /><br />
In addition to these features, I made sure to make the website responsive so that it looks great on all devices, including phones and tablets. I also added a mobile dropdown menu to make it easier for users to access the different pages on smaller screens.
<br /><br />
Overall, I am really happy with how the website turned out and I hope you will check it out at ericpolley.com. If you are interested in learning more about the process of building the website, be sure to check out the tutorial series using the link below.
<br /><br />
Thank you for reading!
<br /><br />
Sincerely,
Eric Polley
<br /><br />

         
          </p>
          
          </article>

        <h4>Links</h4>
        <br />
        <ul>
        <li>
            <a
              href="http://ericpolley.com/#/videos"
              title="Check out my latest Tutorial!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Tutorials</p></strong></
            a>
          </li>
        
          <li>
            <a
              href="http://ericpolley.com"
              title="Check out my Portfolio!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Eric Polley's Website</p></strong></a
            >
          </li>
        </ul>
        </ section >
  )
}
